import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-product",
  "use": "icon-product-usage",
  "viewBox": "0 0 240 240",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 240 240\" id=\"icon-product\"><defs><style>#icon-product .cls-1{stroke:#231815;stroke-miterlimit:10;}</style></defs><path class=\"cls-1\" d=\"M201.83,167.24V72.76L120,25.51,38.17,72.76v94.48L120,214.49Zm-10-5.77L125,200.06V124.74l66.83-38.58ZM120,37.06l68.44,39.51L120,116.08,51.56,76.57ZM48.17,86.16,115,124.74v75.32L48.17,161.47Z\" /><polygon class=\"cls-1\" points=\"67.8 119.03 96.06 135.35 96.06 123.05 67.8 106.73 67.8 119.03\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol